import { useCallback } from "react";
import {
  type DocumentCategoryLabelInput,
  resolveDocumentCategorySlug,
  useTranslation,
} from "@/packages/utils";

export function useDocumentCategoryLabel() {
  const { t } = useTranslation("documents");

  return useCallback(
    (category: DocumentCategoryLabelInput) => {
      const slug = resolveDocumentCategorySlug(category);
      if (slug) {
        return t(`categories.${slug}`, { defaultValue: category.name });
      }
      return category.name;
    },
    [t],
  );
}
